import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { Avatar } from '@99designs/common/components/Avatar';
import { Button } from '@99designs/common/components/Button';
import { Icon } from '@99designs/common/components/Icon';
import { Tooltip } from '@99designs/common/components/Tooltip';
import { times } from 'lodash';
import { AvatarPlaceholder } from '@99designs/common/components/AvatarPlaceholder';
import ConfirmationPopup from './confirmation-popup';
import pluralSelect from '../../../utils/plural-select';
import Drawer from './drawer';
import FinalistDrawerOnboardingPrompt from 'contest/components/onboarding-prompts/FinalistDrawerPrompt';

class ContestFinalistDrawer extends Component {
    render() {
        const finalistCount = this.props.finalists.length;
        return (
            <Drawer>
                <div className="drawer-item-list">
                    {times(this.props.maxFinalists, (index) => (
                        <div className="drawer-item-list__item" key={`item-${index}`}>
                            {index === 0 ? (
                                <FinalistDrawerOnboardingPrompt>
                                    {this.renderFinalist(index)}
                                </FinalistDrawerOnboardingPrompt>
                            ) : (
                                this.renderFinalist(index)
                            )}
                        </div>
                    ))}
                </div>
                <Button onClick={this.props.onConfirm} isDisabled={finalistCount == 0}>
                    <FormattedMessage
                        id={pluralSelect(finalistCount, {
                            zero: 'contest_finalist_drawer_button_confirm_zero',
                            one: 'contest_finalist_drawer_button_confirm_one',
                            other: 'contest_finalist_drawer_button_confirm_other',
                        })}
                        values={{ finalistCount }}
                    />
                </Button>
            </Drawer>
        );
    }

    renderAvatar(user) {
        const showConfirmationPopup = this.props.finalistsNeedingPopup.includes(user);
        return (
            <ConfirmationPopup
                isActive={showConfirmationPopup}
                variations={['small']}
                content={<FormattedMessage id="contest_finalist_drawer_confirmation" />}
            >
                <Tooltip tooltip={user.displayName} hoverCardVariations={['small']}>
                    <Avatar user={user} variations={['small', 'with-shadow']} isLinked={false} />
                </Tooltip>
            </ConfirmationPopup>
        );
    }

    renderFinalist(index) {
        if (index < this.props.finalists.length) {
            const user = this.props.finalists[index];
            return (
                <div className="drawer-item drawer-item--circular">
                    <div className="drawer-item__content">{this.renderAvatar(user)}</div>
                    <div className="drawer-item__remove">
                        <button
                            className="solid-icon-button"
                            onClick={() => this.props.onRemoveFinalistClick(user)}
                        >
                            <Icon type={'x-3'} />
                        </button>
                    </div>
                </div>
            );
        } else {
            return (
                <div className="drawer-item">
                    <AvatarPlaceholder
                        title={this.context.intl.formatMessage({ id: 'avatarplaceholder_title' })}
                    />
                </div>
            );
        }
    }
}

ContestFinalistDrawer.propTypes = {
    maxFinalists: PropTypes.number,
    finalistsNeedingPopup: PropTypes.array.isRequired,
    finalists: PropTypes.arrayOf(
        PropTypes.shape({
            userId: PropTypes.number.isRequired,
            avatarUrl: PropTypes.string.isRequired,
        })
    ).isRequired,
    onConfirm: PropTypes.func.isRequired,
    onRemoveFinalistClick: PropTypes.func.isRequired,
};

ContestFinalistDrawer.contextTypes = {
    intl: PropTypes.object,
};

export default ContestFinalistDrawer;



// WEBPACK FOOTER //
// ./src/web/js/contest/apps/entries/components/contest-finalist-drawer.jsx